var exports = {
  "kL": "FriendSelector.module__container___a3doZG",
  "hJ": "FriendSelector.module__searchField___a3doZG",
  "lA": "FriendSelector.module__searchFieldInner___a3doZG",
  "t$": "FriendSelector.module__selectedPill___a3doZG",
  "DT": "FriendSelector.module__removeButton___a3doZG",
  "qc": "FriendSelector.module__searchIcon___a3doZG",
  "D3": "FriendSelector.module__searchIconFocused___a3doZG",
  "Rt": "FriendSelector.module__searchInput___a3doZG",
  "XG": "FriendSelector.module__scroller___a3doZG",
  "yY": "FriendSelector.module__scrollerNoSearch___a3doZG",
  "p$": "FriendSelector.module__emptyState___a3doZG",
  "q6": "FriendSelector.module__emptyStateText___a3doZG",
  "_s": "FriendSelector.module__groupsContainer___a3doZG",
  "cp": "FriendSelector.module__groupLetter___a3doZG",
  "QS": "FriendSelector.module__friendsList___a3doZG",
  "jZ": "FriendSelector.module__friendButton___a3doZG",
  "An": "FriendSelector.module__friendButtonSelected___a3doZG",
  "FI": "FriendSelector.module__friendButtonDisabled___a3doZG",
  "Hb": "FriendSelector.module__friendInfo___a3doZG",
  "G3": "FriendSelector.module__friendName___a3doZG",
  "HI": "FriendSelector.module__checkboxContainer___a3doZG",
  "Yz": "FriendSelector.module__removeIcon___a3doZG",
};

module.exports = exports;
